export default "__VITE_ASSET__300f0ca3__"